import type { FC, ReactNode } from "react";
import styles from "./styles.module.css";

interface Props {
  children: ReactNode;
}

export const SidebarFooter: FC<Props> = ({ children }) => {
  return <div className={styles["sidebar-footer"]}>{children}</div>;
};
